import { fetcher } from 'services/helpers/responseHandler'

const reconciliationWebhook =
  'https://boldvault.webhook.office.com/webhookb2/139aebc4-e6ef-4cab-a386-0bd664215239@87a865c9-817d-4213-be05-d2e247a09179/IncomingWebhook/a740373a1bd04bceb15c1d7f1907a860/c4d0c55d-6054-4538-bacb-e4e0783ad1df'

const postToTeamsChannel = data =>
  fetch(reconciliationWebhook, {
    method: 'POST',
    header: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then(res => res.json())

const reconciliationGenerate = async ({
  invoiceId,
  inviteBookingConversionDetailId,
  category,
  reason
}) =>
  fetcher.post('billing/reconcile/generate', {
    subsidiaryInvoiceId: invoiceId,
    inviteBookingConversionDetailId,
    generateCategory: category,
    generateReason: reason
  })

const reconlicationEvaluate = async ({
  reconciliationId,
  reconciliationStatus = 'Rejected',
  evaluateReason
}) =>
  fetcher.post('billing/reconcile/evaluate', {
    reconciliationId,
    reconciliationStatus,
    evaluateReason
  })

const skipMonth = async ({ invoiceId }) =>
  fetcher.put('billing/invoice/monthskipped', {
    invoiceId
  })

const getInvoicePdf = async ({ invoiceId }) =>
  fetcher.get(`billing/invoices/${invoiceId}/pdf`)

// invoice/pdf/generate

const regenerateInvoice = async ({ invoiceId }) =>
  fetcher.post(`internalOnly/invoice/pdf/generate`, {
    invoiceId
  })

const invoiceApi = {
  postToTeamsChannel: postToTeamsChannel,
  reconciliation: {
    generate: reconciliationGenerate,
    evaluate: reconlicationEvaluate
  },
  skipMonth,
  getInvoicePdf,
  regenerateInvoice
}

export default invoiceApi
